import { Space, Spin } from 'antd'
import { useCheckPermissionsMap } from 'hooks/useCheckPermission'
import { WithRecord } from '../../../../../../types'
import { useCIMSTableContext } from '../../../../..'
import CIMSLink from '../../../../../../../CIMSLink'
import DisablableRowActionButton from './DisablableRowActionButton'

function CustomRowActionButtons<T extends object>({ record }: WithRecord<T>) {
  const { rowKey, actions } = useCIMSTableContext<T>()
  const custom = actions.row?.custom ?? []
  const [map] = useCheckPermissionsMap(
    custom.map((custom, key) => {
      if (custom.type === 'externalLink') return { key, permission: true }
      else {
        const { permission } = custom
        if (typeof permission === 'function') return { key, permission, record }
        else return { key, permission }
      }
    })
  )
  const resolvedKey =
    typeof rowKey === 'function' ? rowKey(record) : String(record[rowKey])
  const rowItems = custom.map((custom, i) => {
    const key = `${i}-${resolvedKey}`
    let children
    if (custom.type === 'externalLink') {
      const { label: text, href } = custom
      const to = typeof href === 'function' ? href(record) : href
      const label = typeof text === 'function' ? text(record) : text
      children = (
        <CIMSLink external href={to}>
          {label}
        </CIMSLink>
      )
    } else {
      const { text, hidden, onClick, permission: _, type: __, ...rest } = custom
      const hide = typeof hidden === 'function' ? hidden(record) : hidden
      if (hide || !map.get(i)) return null
      children = (
        <DisablableRowActionButton {...rest} record={record} callback={onClick}>
          {typeof text === 'function' ? text(record) : text}
        </DisablableRowActionButton>
      )
    }
    return (
      <Spin key={key} size="small" spinning={custom.loading ?? false}>
        {children}
      </Spin>
    )
  })
  return rowItems.every((item) => item === null) ? null : (
    <Space size={8} direction="vertical">
      {rowItems}
    </Space>
  )
}

export default CustomRowActionButtons
